export { default as Qualifications } from './Qualifications';
export { default as AddReview } from './AddReview';
export { default as Reviews } from './Reviews';
export { default as Portfolio } from './Portfolio';
export { default as Faq } from './Faq';
export { default as UniqueSellingPoints } from './UniqueSellingPoints';
